import { useEffect, useState } from "react";
import { Graph_Dto } from "../../../Interfaces/orderbookGraphInterfaces";
import {
  getDailyLockProfitGraph,
  getDeltaGraph,
  getGammaGraph,
  getPortfoValueGraph,
} from "../../../Requests/adjustment";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { WrappedTimeSeriesChart } from "../../../Components/Timeseries/WrappedTimeSeriesChart";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";

interface IProps {
  activeRowId: number;
}

const Charts = ({ activeRowId }: IProps) => {
  const [deltaGraphData, setDeltaGraphData] = useState<Graph_Dto[]>([]);
  const [gammaGraphData, setGammaGraphData] = useState<Graph_Dto[]>([]);
  const [dailyLockProfitGraphData, setDailyLockProfitGraphData] = useState<
    Graph_Dto[]
  >([]);
  const [portfoValueGraphData, setPortfoValueGraphData] = useState<Graph_Dto[]>(
    []
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!activeRowId) return;
    fetchCharts(true);
    const interval = setInterval(() => fetchCharts(false), 120000);

    return () => clearInterval(interval);
  }, [activeRowId]);

  function fetchCharts(showLoading: boolean) {
    const reqs = [
      getDeltaGraph(activeRowId),
      getGammaGraph(activeRowId),
      getDailyLockProfitGraph(activeRowId),
      getPortfoValueGraph(activeRowId),
    ];

    if (showLoading) setLoading(true);
    Promise.all(reqs)
      .then((resp) => {
        const [deltaGraph, gammaGraph, dailyLock, portfoValueGraph] = resp;
        setDeltaGraphData(deltaGraph);
        setGammaGraphData(gammaGraph);
        setDailyLockProfitGraphData(dailyLock);
        setPortfoValueGraphData(portfoValueGraph);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }

  return (
    <div className="flex flex-row justify-between items-center gap-3 w-full">
      {loading ? <FullScreenLoading /> : <></>}
      <WrappedTimeSeriesChart dataset={deltaGraphData} className="w-full" />
      <div className="h-80 w-px bg-slate-300" />
      <WrappedTimeSeriesChart dataset={gammaGraphData} className="w-full" />
      <div className="h-80 w-px bg-slate-300" />
      <WrappedTimeSeriesChart
        dataset={dailyLockProfitGraphData}
        className="w-full"
      />
      <div className="h-80 w-px bg-slate-300" />
      <WrappedTimeSeriesChart
        dataset={portfoValueGraphData}
        className="w-full"
      />
    </div>
  );
};

export default Charts;
